export function formatErrorMessage(raw: string): string {
  if (!raw) return "";

  try {
    // divide a string em duas partes: antes e depois do primeiro "{"
    const jsonStart = raw.indexOf("{");
    if (jsonStart === -1) return raw; // não tem JSON, retorna como está

    const prefix = raw.substring(0, jsonStart).trim(); // "11/09/25 10:36:"
    const jsonPart = raw.substring(jsonStart);

    const parsed = JSON.parse(jsonPart);

    let msg = parsed.message || "";
    if (Array.isArray(parsed.results) && parsed.results.length > 0) {
      msg += " " + parsed.results.join(" ");
    }

    // junta de volta prefixo + mensagem
    return prefix ? `${prefix} ${msg}` : msg;
  } catch {
    return raw; // fallback se não der parse
  }
}